import { ReactElement } from 'react';

import { EmptyStatePlaceholder, Table } from '@dreryk/react-components';

import { consentTemplateActionTranslationKeys } from '../../../../../translations';

import { useConsentTemplateDataConfiguration, useConsentTemplateTableColumns } from './ConsentTemplateTable.hooks';

const t = consentTemplateActionTranslationKeys.modal.form.table;

type ConsentTemplateTableProps = {
   readonly onApproveAndPrint: VoidFunction;
   readonly patientId: number;
   readonly visitId: number;
   readonly searchText: string | null;
   readonly priorityTemplateIds: number[];
};

export const ConsentTemplateTable = (props: ConsentTemplateTableProps): ReactElement => {
   const dataConfiguration = useConsentTemplateDataConfiguration({
      searchText: props.searchText,
      priorityTemplateIds: props.priorityTemplateIds,
   });
   const columns = useConsentTemplateTableColumns({
      onApproveAndPrint: props.onApproveAndPrint,
      onFavoriteChange: dataConfiguration.refetch,
      patientId: props.patientId,
      visitId: props.visitId,
      priorityTemplateIds: props.priorityTemplateIds,
   });

   return (
      <Table
         columns={columns}
         dataConfiguration={dataConfiguration}
         testId={'consentTemplatesTable'}
         keyExtractor={'id'}
         placeholder={<EmptyStatePlaceholder heading={t.placeholder} testId={'noConsentTemplates'} />}
      />
   );
};
